import asyncSeries from 'async/series';
import asyncEachSeries from 'async/eachSeries';
import UserStore from '../stores/user_store';

import util from '../tools/util';

const QUERY_TIMEOUT = 5 * 60 * 1000;

export default { fetch, hasMultiDownload };

export function hasMultiDownload() {
  return typeof (window as any).showDirectoryPicker === 'function';
}
export function fetch(params, done) {
  const { org_id, media_grant_id, media_list, dir_list, deleted_only } = params;

  let file_list: any[] = [];
  asyncSeries(
    [
      (done) => {
        if (media_list.length > 0) {
          const opts = {
            url: `/web/1/org/${org_id}/media_grant/${media_grant_id}/media_list`,
            query: { media_id_list: media_list.map((m) => m.media_id) },
            timeout: QUERY_TIMEOUT,
          };
          UserStore.post(opts, (err, body) => {
            if (err) {
              util.errorLog('DownloadHelper.fetch: media list err:', err);
            } else {
              body.media_list?.forEach?.((item) => {
                if (Boolean(deleted_only) === Boolean(item.is_deleted)) {
                  file_list.push(item);
                }
              });
            }
            done(err);
          });
        } else {
          done();
        }
      },
      (done) => {
        const fetch_list = dir_list.map((dir) => params.path + dir.name);
        asyncEachSeries(
          fetch_list,
          (prefix_path, done) => {
            const opts = {
              url: `/web/1/org/${org_id}/media_grant/${media_grant_id}/full_dir`,
              query: { prefix_path, deleted: Boolean(deleted_only) },
              timeout: QUERY_TIMEOUT,
            };
            UserStore.get(opts, (err, body) => {
              if (err) {
                util.errorLog('DownloadHelper.fetch: full_dir err:', err);
              } else {
                body.media_list?.forEach?.((item) => {
                  if (Boolean(deleted_only) === Boolean(item.is_deleted)) {
                    file_list.push(item);
                  }
                });
              }
              done(err);
            });
          },
          done
        );
      },
    ],
    (err) => done(err, file_list)
  );
}
